import script from "./SideBarMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./SideBarMenuItem.vue?vue&type=style&index=0&id=4d5638ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d5638ca"]])

export default __exports__